/**
 * Equivalent to:
 * date.toLocaleString('en-US', {
 *     relative: false,
 *     month: 'short',
 *     day: 'numeric'
 * })
 *
 * ie. "Jun 8" or "Feb 27"
 * without relying on the Intl.DateTimeFormat API.
 */
export function getShortDate(date: Date): string {
    return `${getShortMonthName(date)} ${date.getDate()}`;
}

const MONTHS_MAP = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
};

/**
 * Returns the short month name for a given date.
 */
export function getShortMonthName(date: Date): string {
    const month = date.getMonth() + 1;
    return MONTHS_MAP[month];
}
